import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface EditBlogTitleDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  currentTitle: string;
  onConfirm: (newTitle: string) => void;
  isUpdating: boolean;
}

export const EditBlogTitleDialog = ({
  open,
  onOpenChange,
  currentTitle,
  onConfirm,
  isUpdating,
}: EditBlogTitleDialogProps) => {
  const [title, setTitle] = useState(currentTitle);

  // Reset title when dialog opens
  useEffect(() => {
    if (open) {
      setTitle(currentTitle);
    }
  }, [open, currentTitle]);

  const handleConfirm = () => {
    const trimmedTitle = title.trim();
    if (trimmedTitle && trimmedTitle !== currentTitle) {
      onConfirm(trimmedTitle);
    }
  };

  const isValid = title.trim().length > 0;
  const hasChanged = title.trim() !== currentTitle;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Chỉnh Sửa Tên Blog</DialogTitle>
          <DialogDescription>
            Nhập tên mới cho blog của bạn
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="blog-title">Tên blog</Label>
            <Input
              id="blog-title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Nhập tên blog..."
              disabled={isUpdating}
              autoFocus
              onKeyDown={(e) => {
                if (e.key === 'Enter' && isValid && hasChanged) {
                  handleConfirm();
                }
              }}
            />
            <p className="text-xs text-gray-500">
              {title.length} / 100 ký tự
            </p>
          </div>
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isUpdating}
          >
            Hủy
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={!isValid || !hasChanged || isUpdating}
          >
            {isUpdating ? 'Đang lưu...' : 'Lưu thay đổi'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
